import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

// Grouped top-nav menu — each inner array is a section, rendered with a divider between.
const GROUPS = [
  [{ to: '/admin', label: 'Dashboard', icon: '⌂', end: true }],
  [{ to: '/admin/dealers', label: 'Dealers', icon: '🏢' },
   { to: '/admin/feeds', label: 'Feeds', icon: '📡' },
   { to: '/admin/file-upload', label: 'File Upload', icon: '📤' },
   { to: '/admin/manual-review', label: 'Manual Review', icon: '🔎' },
   { to: '/admin/display-orders', label: 'Display Orders', icon: '🖼️' }],
  [{ to: '/admin/users', label: 'Users', icon: '👤' },
   { to: '/admin/photographers', label: 'Photographers', icon: '📷' }],
  [{ to: '/admin/rates', label: 'Rate Cards', icon: '💲' },
   { to: '/admin/scheduling', label: 'Scheduling', icon: '🗓️' },
   { to: '/admin/activity', label: 'Activity Log', icon: '📜' },
   { to: '/admin/billing', label: 'Reconciliation', icon: '🧾' }],
  [{ to: '/admin/mobile', label: 'Mobile Activity', icon: '📱' },
   { to: '/admin/double-shoot', label: 'Double-Shoot', icon: '🆚' },
   { to: '/admin/reports', label: 'Reports', icon: '📄' }],
  [{ to: '/admin/health', label: 'Health', icon: '🩺' }],
];

function adminLabel() {
  try {
    const t = localStorage.getItem('adminAuth');
    const p = JSON.parse(atob(t.split('.')[1]));
    return p.email || p.sub || (p.role ? p.role[0].toUpperCase() + p.role.slice(1) : 'Admin');
  } catch {
    return 'Admin';
  }
}

export default function AdminLayout() {
  const navigate = useNavigate();
  const logout = () => { localStorage.removeItem('adminAuth'); navigate('/admin/login'); };

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6f8' }}>
      <div style={shell}>
        {/* Top header */}
        <div style={header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 18, fontWeight: 700, letterSpacing: '0.02em' }}>AutoLota</span>
            <span style={{ fontSize: 13, opacity: 0.7, fontWeight: 500 }}>Admin Portal</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span style={{ fontSize: 13, opacity: 0.85 }}>{adminLabel()}</span>
            <button onClick={logout} style={logoutBtn}>Logout</button>
          </div>
        </div>
        {/* Grouped menu bar */}
        <nav style={menuBar}>
          {GROUPS.map((group, gi) => (
            <React.Fragment key={gi}>
              {gi > 0 && <span style={divider} />}
              {group.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.end}
                  style={({ isActive }) => ({ ...link, ...(isActive ? linkActive : {}) })}>
                  <span style={{ marginRight: 6 }}>{item.icon}</span>{item.label}
                </NavLink>
              ))}
            </React.Fragment>
          ))}
        </nav>
      </div>
      <main style={{ padding: '0 0 40px' }}>
        <Outlet />
      </main>
    </div>
  );
}

const shell = { position: 'sticky', top: 0, zIndex: 50, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' };
const header = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  background: '#1f2937', color: '#fff', padding: '0 24px', height: 52,
};
const logoutBtn = {
  background: 'rgba(255,255,255,0.12)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)',
  borderRadius: 6, padding: '5px 14px', fontSize: 13, cursor: 'pointer',
};
const menuBar = {
  display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2,
  background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '0 16px',
};
const link = {
  display: 'inline-flex', alignItems: 'center', textDecoration: 'none',
  color: '#374151', fontSize: 14, fontWeight: 500, padding: '12px 12px',
  borderBottom: '3px solid transparent', whiteSpace: 'nowrap',
};
const linkActive = { color: '#0078D4', borderBottom: '3px solid #0078D4', fontWeight: 600 };
const divider = { width: 1, height: 22, background: '#e5e7eb', margin: '0 8px' };
